import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { useTheme, createUseStyles } from 'react-jss';
import { Container } from '@sm/wds-react';
import { Typography } from '@wds/typography';
import { IconCheckCircle } from '@sm/wds-icons';

const COPY = defineMessages({
  THANK_YOU: {
    id: 'SurveyThanks.EmbeddedNonBranded.ThankYou',
    defaultMessage: 'Thanks for taking this survey.',
    description:
      '[Type: Header][vis: high] - The only message on the webpage. Used on a Nonbranded webpage to say thank you to survey respondents and signal the end of the survey.',
  },
});

const useStyles = createUseStyles(theme => {
  return {
    embeddedContainer: {
      height: theme.util.fullHeight,
      backgroundColor: theme.endpageColors.embeddedNonBranded.backgroundColor,
    },
    thankYouMessage: {
      padding: theme.spacing[3],
    },
  };
});

const EmbeddedNonBranded = () => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <Container
      className={classes.embeddedContainer}
      flex
      flexAlign="center"
      flexJustify="center"
      flexDirection="column"
    >
      <Container>
        <IconCheckCircle color="primary" size="lg" />
      </Container>
      <Container>
        <Typography color="darkMuted" component="div" p={3} variant="body">
          {t(COPY.THANK_YOU)}
        </Typography>
      </Container>
    </Container>
  );
};

export default EmbeddedNonBranded;
